const scrollUpBtn = document.querySelector('.scrollup');

if (scrollUpBtn) {
    scrollUpBtn.addEventListener('click', () => {
        window.scrollTo(0, 0);
    });
}
